<template>
    <el-container>
        <el-header height="88px">
            <HeaderNav :curHash="'case'" />
        </el-header>
        <el-main :style="`height:${contentHeight}; flex-grow:1; padding: 0`">

        </el-main>
        <el-footer height="54px">
            <Footer />
        </el-footer>
    </el-container>
</template>

<script>
import HeaderNav from '../components/header.vue'
import Footer from '../components/footer.vue'
export default {
  name: 'Case',
  components: { HeaderNav, Footer },
  data () {
    return {
      contentHeight: 0
    }
  },
  methods: {
  },
  mounted () {
      this.$nextTick(() => {
          this.contentHeight = document.documentElement.clientHeight - 54 - 88 + 'px'
      })
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.el-carousel__item{
    img{
        width: 100%;
        height: 370px;
    }
}
    .torvandom-body{
        .el-row {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .el-col {
            border-radius: 4px;
        }
        .bg-purple-dark {
            background: #99a9bf;
        }
        .bg-purple {
            background: #d3dce6;
        }
        .bg-purple-light {
            background: #e5e9f2;
        }
        .grid-content {
            border-radius: 4px;
            min-height: 36px;
        }
        .row-bg {
            padding: 10px 0;
            background-color: #f9fafc;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/case.vue